module.exports = {
  apps: 'Apps',
  autoJobs: 'Auto Jobs',
  auditLog: 'Audit Log',
  companies: 'Firmen',
  configUpdates: 'Config Updates',
  catalogs: 'Kataloge',
  callerId: 'CallerID Servers',
  corporations: 'Corporations',
  domains: 'Domains',
  languageMappings: 'Language Mappings',
  licenses: 'Licenses',
  licenseReports: 'License Reports',
  webshopusageReports: 'Webshopusage Reports',
  model: 'Model',
  printTemplates: 'Print Templates',
  manufacturer: 'Manufacturer',
  discounts: 'Discounts',
  domain: 'Domain',
  moonBackup: 'Moon Backup',
  moonInstances: 'Moon Instances',
  systemlog: 'System Logs',
  system: 'System',
  tables: 'Tische',
  tableName: 'Tisch Name',
  tableCategory: 'Tisch Kategorie Name',
  tableCategories: 'Tisch Kategorie',
  webShops: 'Web Shops',
  webspace: 'Web Spaces',
  accounts: 'Benutzer',
  printers: 'Printers',
  printServers: 'Druck Servers',
  login: 'Login',
  logout: 'Logout',
  emailConf: 'Email Configuration Settings',
  pending: 'Pending Orders',
  lastPending: 'Last Pending Order',
  historyId: 'History ID',
  srNo: 'Sr No',
  orderIdSource: 'Order ID/Source',
  orderCode: 'Order Code',
  customerName: 'Customer Name',
  totalAmount: 'Total Amount',
  contactedOn: 'Last Contacted On',
  templateType: 'Template Type',
  templateName: 'Template Name',
  day: 'Day',
  start: 'Start',
  end: 'End',
  catalogVersion: 'Katalog Version',
  licenseType: 'License Type',
  licenseKey: 'License Key',
  moonInstName: 'Moon Instace Name',
  activationDate: 'Activation Date',
  expiryDate: 'Expiry Date',
  createdDate: 'Created Date',
  modifiedDate: 'Modified Date',
  limit: 'Limit',
  callerIdName: 'CallerID Server Name',
  webShopResourceId: 'Web Shop Resource ID',
  noOfOrders: 'No Of Orders',
  ordersSum: 'Orders Sum',
  prefixLines: 'Prefix Lines',
  postixLines: 'Postfix Lines',
  jobName: 'Job Name',
  jobDesc: 'Job Description',
  lastExec: 'Last Executed On',
  nextExec: 'Next Planned Execution On',
  fromMiles: 'From Miles',
  toMiles: 'To Miles',
  charges: 'Charges',
  defaultCharges: 'Default Charges',
  fromAmount: 'From Amount',
  toAmount: 'To Amount',
  action: 'Action',
  sourceVersion: 'Source/Version',
  createdBy: 'Created By',
  synched: 'Synched On',
  instanceName: 'Instance Name',
  conditions: 'Conditions',
  values: 'Values',
  callerIdServers: 'CallerID Servers',
  webShopResource: 'Web Shop Resources',
  catalogName: 'Katalog Name',
  emailPhone: 'Email/Phone',
  webshop: 'webshop',
  orderingApp: 'ordering app',
  pricingInvoices: 'Invoices',
  pricingGroupName: 'Pricing Group Name',
  resourceTracking: 'Resource Tracking',
  resourceType: 'Resource Type/ID',
  trackingAction: 'Tracking Action',
  closedReason: 'Closed/Reason For Closure',
  cashRegister: 'Cash Register',
  htmlHints: 'Html Hints',
  images: 'Bilder',
  label: 'Label',
  companyGeneralData: 'Company General Data',
  companySettings: 'Company Settings',
  companyAddress: 'Company Address',
  properties: 'Properties',
  paymentSummary: 'Payment Summary',
  paymentType: 'Payment Type',
  amount: 'Amount',
  paymentGatewaySettings: 'Payment Gateway Settings',
  paymentTerminals: 'Zahlungs Terminals',
  paymentServers: 'Zahlungsserver',
  delivery: 'Delivery',
  keys: 'Keys',
  automatedPrinting: 'Automated printing',
  fromMeters: 'From Meters',
  toMeters: 'To Meters',
  companyInfo: 'Company Info',
  account: 'Account',
  roleManagement: 'Role Management',
  originalVersion: 'Ursprüngliche Version',
  views: 'Sichten',
  allergens: 'Allergene',
  massAddRemove: 'Maßenänderung Hinzufügen/Entfernen',
  items: 'Artikel',
  edit: 'Edit',
  add: 'Add',
  item: 'Item',
  printerCategories: 'Druckkategorien',
  abbreviation: 'Abkürzung',
  name: 'Name',
  description: 'Beschreibung',
  sizes: 'Größen',
  variants: 'Varianten',
  options: 'Optionen',
  styles: 'Stil',
  settings: 'Einstellungen',
  color: 'Farben',
  language: 'Sprachen',
  default: 'Standard',
  actions: 'Aktionen',
  massTranslate: 'Maßen Übersetzung',
  overwriteOptions: 'Zu überschreiben',
  abbrevation: 'Abkürzung',
  taxCategory: 'Tax category',
  courseNo: 'Course No',
  vat: 'VAT'
};



// WEBPACK FOOTER //
// ./src/lang/de/header.js